import { useParams } from 'react-router-dom';
import { FilesPage } from './FilesPage.tsx';
import { EmptyState } from '../components/common/EmptyState.tsx';

/** 공유 폴더는 별도 네임스페이스라 같은 파일 탐색기를 다른 루트로 재사용한다. */
export function SharedDrivePage() {
  const { nsId } = useParams();
  if (!nsId) return <EmptyState title="공유 폴더를 찾을 수 없습니다" />;
  return <FilesPage namespaceId={nsId} base={`/ns/${nsId}`} />;
}
